import styled, { css } from "styled-components";
import { Dropdown } from "antd";
import { theme } from "../../../config";
import { DropdownParams } from "./types";

const PrimaryDropdown = css`
  background: ${theme.colors.secondary};
  color: ${theme.colors.white};
  border: none;

  &:hover {
    background: ${theme.colors.secondary1};
    color: ${theme.colors.white};
  }

  &:focus {
    border: 1px solid ${theme.colors.secondary};
    background: ${theme.colors.secondary};
    color: ${theme.colors.white};
  }

  &:disabled {
    background: ${theme.colors.neutral.black5};
    color: ${theme.colors.neutral.black4};
  }
`;

const DefaultDropdown = css`
  color: ${theme.colors.secondary};
  border: 1px solid ${theme.colors.secondary};
  
  &:hover {
    border: 1px solid ${theme.colors.secondary1};
    color: ${theme.colors.secondary1};
  }

  &:focus {
    border: 1px solid ${theme.colors.secondary};
    color: ${theme.colors.secondary};
  }

  &:disabled {
    border: 1px solid ${theme.colors.neutral.black4};
    color: ${theme.colors.neutral.black4};
  }
`;

export const DropdownStyled = styled(Dropdown)`
  height: 40px;
  border-radius: 4px;
  font-size: 16px;

  ${(props: DropdownParams) =>
    props.type === "primary" ? PrimaryDropdown : DefaultDropdown};
`;
